<template>
    <b-modal v-model="visible" title="Группа строительных объектов" content-class="argus-glass-dialog" :no-close-on-backdrop="busy" :no-close-on-esc="busy" :hide-header-close="busy" scrollable @hide="preventBusyClose">
        <p>{{ object && object.name }}</p>
        <b-form-group label="Группа объектов" label-for="object-membership-group">
            <b-form-select id="object-membership-group" v-model="target" :options="options" :disabled="busy || loading" @change="previewChange"/>
        </b-form-group>
        <div v-if="preview">
            <p>Было: <strong>{{ preview.from ? preview.from.name : 'Без группы' }}</strong>. Станет: <strong>{{ preview.to ? preview.to.name : 'Без группы' }}</strong>.</p>
            <div v-for="section in impacts" :key="section.title" class="mb-3">
                <strong>{{ section.title }}</strong>
                <ul v-if="section.rows.length" class="pl-3"><li v-for="row in section.rows" :key="row.id"><a v-if="row.chat_id" :href="href(row.chat_id)" target="_blank" rel="noopener noreferrer">{{ row.name }} ↗</a><span v-else>{{ row.name }} · {{ state(row.status) }}</span></li></ul>
                <p v-else class="text-muted">Нет привязанных или создающихся групп.</p>
            </div>
            <b-alert :show="!!preview.conflicts.length" variant="warning">У объекта уже есть собственные группы с пересекающимся назначением. Общие и собственные чаты будут показаны рядом.</b-alert>
            <p class="small text-muted">{{ changed ? 'Изменятся ссылки в карточке объекта. Участники и переписка Telegram-групп не изменятся.' : 'Принадлежность объекта не изменится.' }}</p>
        </div>
        <template #modal-footer="{cancel}">
            <div v-if="loading" class="w-100" role="status">Проверяем состав и Telegram-группы…</div>
            <div v-if="notice" class="w-100 text-warning" role="alert">{{ notice }}</div>
            <div v-if="error" class="w-100 text-danger" role="alert">{{ error }} <b-button size="sm" variant="link" :disabled="busy" @click="retry">Повторить проверку</b-button></div>
            <b-button variant="outline-secondary" :disabled="busy" @click="cancel()">Отмена</b-button>
            <b-button variant="primary" :disabled="!canSave" @click="save">{{ saveTitle }}</b-button>
        </template>
    </b-modal>
</template>
<script>
import api from '@/utils/api';
import {telegramGroupHref, telegramGroupStateText, objectMembershipId} from '@/utils/objectTelegramGroups';
export default {
    data: () => ({
        visible: false,
        object: null,
        groups: [],
        target: null,
        preview: null,
        busy: false,
        loading: false,
        error: '',
        notice: ''
    }),
    computed: {
        options() {
            return [{value: null, text: 'Без группы'}].concat(this.groups.map(row => ({value: Number(row.id), text: row.name})));
        },
        changed() {
            return this.preview && Number(this.preview.from && this.preview.from.id) !== Number(this.preview.to && this.preview.to.id);
        },
        impacts() {
            if (!this.changed) return [];
            return [
                {title: 'Исчезнут из карточки', rows: this.preview.leaving},
                {title: 'Появятся в карточке', rows: this.preview.joining}
            ];
        },
        canSave() { return !this.busy && !this.loading && !this.error && !!this.preview && !!this.changed; },
        saveTitle() {
            if (this.busy) return 'Сохранение…';
            return this.preview && this.preview.required ? 'Подтвердить изменение группы' : 'Сохранить';
        },
        membershipRoot() { return `/api/object-groups/objects/${this.object.building_id}/group`; }
    },
    methods: {
        href: telegramGroupHref,
        state: telegramGroupStateText,
        preventBusyClose(event) { if (this.busy) event.preventDefault(); },
        async open(object) {
            this.object = object;
            this.target = objectMembershipId(object);
            this.preview = null;
            this.notice = '';
            this.visible = true;
            await this.retry();
        },
        async retry() {
            this.loading = true;
            this.error = '';
            try {
                const {data} = await api.get('/api/object-groups/manage', {ignoreModal: true});
                this.groups = data.groups;
            } catch (error) {
                this.error = this.message(error);
            } finally {
                this.loading = false;
            }
            if (!this.error) await this.previewChange();
        },
        message(error) {
            const response = error.response && error.response.data;
            return response && (response.message || response.msg) || 'Не удалось проверить изменение группы. Введённые значения сохранены.';
        },
        async previewChange() {
            const revision = this._revision = (this._revision || 0) + 1;
            this.loading = true;
            this.error = '';
            this.notice = '';
            this.preview = null;
            try {
                const {data} = await api.post(`${this.membershipRoot}/preview`, {object_group_id: this.target}, {ignoreModal: true});
                if (revision === this._revision) this.preview = data;
            } catch (error) {
                if (revision === this._revision) this.error = this.message(error);
            } finally {
                if (revision === this._revision) this.loading = false;
            }
        },
        applySaveError(error) {
            const data = error.response && error.response.data;
            if (!data || !data.preview) {
                this.error = this.message(error);
                return;
            }
            this.preview = data.preview;
            this.error = '';
            this.notice = (data.message || data.msg || 'Состав изменился.') + ' Проверьте изменения и подтвердите повторно.';
        },
        async save() {
            if (!this.canSave) return;
            this.busy = true;
            this.error = '';
            try {
                await api.put(this.membershipRoot, {
                    object_group_id: this.target,
                    expected_object_group_id: this.preview.from && this.preview.from.id,
                    scope_confirmation: this.preview.confirmation_token
                }, {ignoreModal: true});
                this.busy = false;
                this.visible = false;
                this.$emit('changed');
            } catch (error) {
                this.applySaveError(error);
            } finally {
                this.busy = false;
            }
        }
    }
};
</script>
